import Vue from 'vue';
import { stringfy } from '_utils/string';

export default {
  methods: {
    formatSlug(option) {
      option.slug = stringfy(option.name);
    },
    updateItem(index, type, newValue) {
      Vue.set(this[type], index, newValue);
    },
  },
};
